export default function priceToggle() {
    const pricingToggles = document.querySelectorAll('.elementor-widget-tz-pricing-table');

    pricingToggles.forEach(toggle => {
        const input = toggle.querySelector('.tz-pricing-toggle-input');
        const monthlyLabel = toggle.querySelectorAll('.tz-pricing-monthly');
        const yearlyLabel = toggle.querySelectorAll('.tz-pricing-yearly');

        if (!input) return;

        input.addEventListener('change', () => {
            const isYearly = input.checked;
            monthlyLabel.forEach( monthly => {
                monthly.classList.toggle('active', !isYearly);
            } );
            yearlyLabel.forEach( yearly => {
                yearly.classList.toggle('active', isYearly);
            } );
        });
    });
}